const Affiliate = () => {
    return (
        <div>
            Affiliate 1
        </div>
    )
}

export default Affiliate;